let apiUrl = process.env.VUE_APP_API_URL
let systemName = process.env.VUE_APP_SYSTEM_NAME
let originLat = process.env.VUE_APP_ORIGIN_LAT
let originLng = process.env.VUE_APP_ORIGIN_LNG
let demoMode = process.env.VUE_APP_DEMO_MODE
export const Keys = {
    VUE_APP_API_URL: apiUrl,
    VUE_APP_SYSTEM_NAME: systemName,
    VUE_APP_ORIGIN_LAT: originLat,
    VUE_APP_ORIGIN_LNG: originLng,
    VUE_APP_DEMO_MODE: demoMode
};

export const isDemoMode = () =>
    String(demoMode).toLowerCase() === 'true';
